/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
  type Option,
  type OptionOrNullable,
} from '@solana/kit';
import {
  getEquatableOperatorDecoder,
  getEquatableOperatorEncoder,
  getIntegerOperatorDecoder,
  getIntegerOperatorEncoder,
  type EquatableOperator,
  type EquatableOperatorArgs,
  type IntegerOperator,
  type IntegerOperatorArgs,
} from '.';

export type MintAccountAssertion =
  | {
      __kind: 'MintAuthority';
      value: Option<Address>;
      operator: EquatableOperator;
    }
  | { __kind: 'Supply'; value: bigint; operator: IntegerOperator }
  | { __kind: 'Decimals'; value: number; operator: IntegerOperator }
  | { __kind: 'IsInitialized'; value: boolean; operator: EquatableOperator }
  | {
      __kind: 'FreezeAuthority';
      value: Option<Address>;
      operator: EquatableOperator;
    };

export type MintAccountAssertionArgs =
  | {
      __kind: 'MintAuthority';
      value: OptionOrNullable<Address>;
      operator: EquatableOperatorArgs;
    }
  | { __kind: 'Supply'; value: number | bigint; operator: IntegerOperatorArgs }
  | { __kind: 'Decimals'; value: number; operator: IntegerOperatorArgs }
  | { __kind: 'IsInitialized'; value: boolean; operator: EquatableOperatorArgs }
  | {
      __kind: 'FreezeAuthority';
      value: OptionOrNullable<Address>;
      operator: EquatableOperatorArgs;
    };

export function getMintAccountAssertionEncoder(): Encoder<MintAccountAssertionArgs> {
  return getDiscriminatedUnionEncoder([
    [
      'MintAuthority',
      getStructEncoder([
        ['value', getOptionEncoder(getAddressEncoder())],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
    [
      'Supply',
      getStructEncoder([
        ['value', getU64Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'Decimals',
      getStructEncoder([
        ['value', getU8Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
    [
      'IsInitialized',
      getStructEncoder([
        ['value', getBooleanEncoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
    [
      'FreezeAuthority',
      getStructEncoder([
        ['value', getOptionEncoder(getAddressEncoder())],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
  ]);
}

export function getMintAccountAssertionDecoder(): Decoder<MintAccountAssertion> {
  return getDiscriminatedUnionDecoder([
    [
      'MintAuthority',
      getStructDecoder([
        ['value', getOptionDecoder(getAddressDecoder())],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
    [
      'Supply',
      getStructDecoder([
        ['value', getU64Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'Decimals',
      getStructDecoder([
        ['value', getU8Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
    [
      'IsInitialized',
      getStructDecoder([
        ['value', getBooleanDecoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
    [
      'FreezeAuthority',
      getStructDecoder([
        ['value', getOptionDecoder(getAddressDecoder())],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
  ]);
}

export function getMintAccountAssertionCodec(): Codec<
  MintAccountAssertionArgs,
  MintAccountAssertion
> {
  return combineCodec(
    getMintAccountAssertionEncoder(),
    getMintAccountAssertionDecoder()
  );
}

// Data Enum Helpers.
export function mintAccountAssertion(
  kind: 'MintAuthority',
  data: GetDiscriminatedUnionVariantContent<
    MintAccountAssertionArgs,
    '__kind',
    'MintAuthority'
  >
): GetDiscriminatedUnionVariant<
  MintAccountAssertionArgs,
  '__kind',
  'MintAuthority'
>;
export function mintAccountAssertion(
  kind: 'Supply',
  data: GetDiscriminatedUnionVariantContent<
    MintAccountAssertionArgs,
    '__kind',
    'Supply'
  >
): GetDiscriminatedUnionVariant<MintAccountAssertionArgs, '__kind', 'Supply'>;
export function mintAccountAssertion(
  kind: 'Decimals',
  data: GetDiscriminatedUnionVariantContent<
    MintAccountAssertionArgs,
    '__kind',
    'Decimals'
  >
): GetDiscriminatedUnionVariant<MintAccountAssertionArgs, '__kind', 'Decimals'>;
export function mintAccountAssertion(
  kind: 'IsInitialized',
  data: GetDiscriminatedUnionVariantContent<
    MintAccountAssertionArgs,
    '__kind',
    'IsInitialized'
  >
): GetDiscriminatedUnionVariant<
  MintAccountAssertionArgs,
  '__kind',
  'IsInitialized'
>;
export function mintAccountAssertion(
  kind: 'FreezeAuthority',
  data: GetDiscriminatedUnionVariantContent<
    MintAccountAssertionArgs,
    '__kind',
    'FreezeAuthority'
  >
): GetDiscriminatedUnionVariant<
  MintAccountAssertionArgs,
  '__kind',
  'FreezeAuthority'
>;
export function mintAccountAssertion<
  K extends MintAccountAssertionArgs['__kind'],
  Data,
>(kind: K, data?: Data) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isMintAccountAssertion<
  K extends MintAccountAssertion['__kind'],
>(
  kind: K,
  value: MintAccountAssertion
): value is MintAccountAssertion & { __kind: K } {
  return value.__kind === kind;
}
